import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { SITE } from "../data/site";
import { PRODUCTS, CATEGORIES } from "../data/products";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#080D18]">
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-display text-2xl font-bold tracking-wide text-white">
            TERRA<span className="text-amber-500">BLOOM</span>
          </p>
          <p className="mt-1 font-mono text-[10px] tracking-[0.3em] text-slate-500">{SITE.brandSub} — DUBAI, UAE</p>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Oil & petrochemicals trading house supplying rubber process oils, base oils, waxes and lubricants to
            industrial buyers worldwide.
          </p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500">Products</p>
          {CATEGORIES.map((cat) => (
            <div key={cat.id} className="mt-5">
              <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500">{cat.label}</p>
              <ul className="mt-2 space-y-3">
                {PRODUCTS.filter((p) => p.category === cat.id).map((p) => (
                  <li key={p.slug}>
                    <Link
                      to={`/products/${p.slug}`}
                      data-testid={`footer-product-${p.slug}`}
                      className="group inline-flex items-center gap-1 text-sm text-slate-400 transition-colors hover:text-white"
                    >
                      {p.shortName}
                      <ArrowUpRight className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="mt-5">
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500">Steel & TMT</p>
            <ul className="mt-2 space-y-3">
              <li>
                <Link
                  to="/steel"
                  data-testid="footer-steel"
                  className="group inline-flex items-center gap-1 text-sm text-slate-400 transition-colors hover:text-white"
                >
                  Steel & TMT Products
                  <ArrowUpRight className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500">Company</p>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li><Link data-testid="footer-about" className="hover:text-white transition-colors" to="/about">About Us</Link></li>
            <li><Link data-testid="footer-why-us" className="hover:text-white transition-colors" to="/why-us">Why Us</Link></li>
            <li><Link data-testid="footer-contact" className="hover:text-white transition-colors" to="/contact">Contact</Link></li>
            <li>
              <a data-testid="footer-brochure" className="hover:text-white transition-colors" href={SITE.brochure} target="_blank" rel="noopener noreferrer">
                Company Brochure (PDF)
              </a>
            </li>
            <li><Link data-testid="footer-privacy" className="hover:text-white transition-colors" to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500">Head Office</p>
          <ul className="mt-5 space-y-4 text-sm text-slate-400">
            <li className="flex gap-3"><MapPin className="h-4 w-4 shrink-0 text-amber-500" /><span>{SITE.address}</span></li>
            <li>
              <a href={SITE.phoneHref} data-testid="footer-phone" className="flex gap-3 hover:text-white transition-colors">
                <Phone className="h-4 w-4 shrink-0 text-amber-500" /><span>{SITE.phone}</span>
              </a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex gap-3 hover:text-white transition-colors">
                <Mail className="h-4 w-4 shrink-0 text-amber-500" /><span>{SITE.email}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
          ISO 9001:2015 aligned QA — SGS / BV inspected shipments
        </p>
      </div>
    </div>
  </footer>
);
